var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatalogIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    fill: "#231F20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 14.416H17.0417V38.5827H14.625V14.416ZM23.0833 19.2493H31.5417V21.666H23.0833V19.2493ZM23.0833 24.0827H31.5417V26.4993H23.0833V24.0827Z",
    fill: "#F9BD2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9583 13.416H18.25V37.5827H33.9583C35.2911 37.5827 36.375 36.4988 36.375 35.166V15.8327C36.375 14.4999 35.2911 13.416 33.9583 13.416ZM33.9583 35.166H20.6667V15.8327H33.9583V35.166Z",
    fill: "#F9BD2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogIcon);
export default __webpack_public_path__ + "static/media/catalog-icon.c0c3e7ebbfcfa360e3e2271cd6956172.svg";
export { ForwardRef as ReactComponent };